import { NavLink, Outlet } from 'react-router';
import { Brand } from '../brand/Logo';
import './Layout.css';

export function Layout() {
  return (
    <div className="layout-shell">
      <a className={`layout-skip btn btn-small`} href="#main">
        Skip to content
      </a>
      <header className="layout-header">
        <NavLink to="/" className="layout-home" aria-label="Halvard home">
          <Brand size={26} />
        </NavLink>
        <nav aria-label="Main" className="layout-nav">
          <NavLink to="/play/local">Play</NavLink>
          <NavLink to="/learn">Learn</NavLink>
          <NavLink to="/mountain">Mountain</NavLink>
        </nav>
      </header>
      <main id="main" className="layout-main">
        <Outlet />
      </main>
    </div>
  );
}
